<script lang="ts" setup>
import { isMobile } from "@/modules/common";
import { ModelEnum, ModelList } from "@/enums/chatEnums";
import { Popup } from "vant";
import { computed, ref } from "vue";
import { useGlobalUser } from "@/stores/globalUser";

const props = defineProps<{
  show: boolean;
  initialModel: ModelEnum;
}>();
const emit = defineEmits<{
  (event: "update:show", value: boolean): void;
  (event: "confirm", value: ModelEnum): void;
}>();
const value = ref<ModelEnum>(props.initialModel);
const userStore = useGlobalUser();
const validModelList = computed(() => {
  const validList = ModelList.filter((item) => !item.hide);
  if (userStore.isHideNSFW) {
    return validList.filter((item) => !item.isNsfwSupport);
  } else {
    return validList;
  }
});
</script>
<template>
  <Popup
    :position="isMobile() ? 'bottom' : 'center'"
    :show="show"
    class="max-h-[80%] w-full lg:max-w-[500px] grid grid-rows-[auto_1fr]"
    round
    @update:show="emit('update:show', $event)"
  >
    <ThreadsNav show-back>
      <template #left>
        <button
          class="btn btn-ghost btn-sm"
          @click="emit('update:show', false)"
        >
          {{ $t("Message.cancel") }}
        </button>
      </template>
      <template #center>
        <div class="font-bold text-base">{{ $t("Chats.selectModel") }}</div>
      </template>
      <template #right>
        <button
          class="btn btn-primary btn-sm"
          @click="
            emit('confirm', value);
            emit('update:show', false);
          "
        >
          {{ $t("Buttons.confirm") }}
        </button>
      </template>
    </ThreadsNav>
    <div class="p-4 flex flex-col overflow-y-auto gap-2">
      <div class="p-4 flex items-center gap-2 bg-neutral/50 rounded">
        <i class="iconify mingcute--information-line" />
        {{ $t("Chats.modelTip") }}
      </div>
      <div
        v-for="item in validModelList"
        :key="item.value"
        :class="{
          'border-primary': value === item.value,
          'border-transparent': value !== item.value,
        }"
        class="bg-neutral rounded-lg p-4 flex flex-col gap-2 cursor-pointer border"
        @click="value = item.value"
      >
        <div class="flex justify-between items-center">
          <div class="font-semibold text-base">{{ item.label }}</div>
          <div
            :class="{
              'bg-primary-gradient': item.costType === 'powerCube',
              'bg-love': item.costType === 'crystal',
            }"
            class="flex items-center gap-1 w-fit py-[1px] px-2 rounded-full text-sm"
          >
            <CrystalIcon v-if="item.costType === 'crystal'" />
            <PowerIcon v-else />
            <div>{{ item.cost }}</div>
            <span>{{ $t("Chats.perMessage") }}</span>
          </div>
        </div>
        <div class="flex gap-2 items-center">
          <div class="flex gap-2">
            <div>{{ $t("Chats.tokenLimit") }}:</div>
            <div>{{ item.contextLength }}</div>
          </div>
          <template v-if="!userStore.isHideNSFW">
            ·
            <div class="flex">
              <div
                v-if="item.isNsfwSupport"
                class="badge badge-warning badge-sm"
              >
                {{ $t("Chats.uncensored") }}
              </div>
              <div v-else class="badge badge-sm">
                {{ $t("Chats.censored") }}
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
  </Popup>
</template>
